var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinanceleaseSelling({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 90,
    viewBox: "0 0 70 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Search_results_for_House_contract_-_Flaticon-2",
    "data-name": "Search results for House contract - Flaticon-2",
    transform: "translate(-58.95 -0.009)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10518",
    "data-name": "Group 10518",
    transform: "translate(67.204 40.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10517",
    "data-name": "Group 10517"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10127",
    "data-name": "Path 10127",
    d: "M158.2,229.53H107.352a1.3,1.3,0,1,0,0,2.59H158.2a1.3,1.3,0,0,0,0-2.59Z",
    transform: "translate(-105.939 -229.525)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10520",
    "data-name": "Group 10520",
    transform: "translate(67.204 53.547)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10519",
    "data-name": "Group 10519"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10128",
    "data-name": "Path 10128",
    d: "M131.428,304.72H107.353a1.3,1.3,0,1,0,0,2.59h24.075a1.3,1.3,0,0,0,0-2.59Z",
    transform: "translate(-105.939 -304.715)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10522",
    "data-name": "Group 10522",
    transform: "translate(67.432 79.898)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10521",
    "data-name": "Group 10521"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10129",
    "data-name": "Path 10129",
    d: "M136.7,455.1H107.353a1.3,1.3,0,0,0,0,2.59h29.341a1.3,1.3,0,0,0,0-2.59Z",
    transform: "translate(-106.167 -455.1)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10524",
    "data-name": "Group 10524",
    transform: "translate(66.931 7.943)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10523",
    "data-name": "Group 10523"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10130",
    "data-name": "Path 10130",
    d: "M128.2,55.2,117.369,45.029a1.3,1.3,0,0,0-1.773,0L104.766,55.2a1.3,1.3,0,1,0,1.773,1.888l9.943-9.34,9.943,9.34A1.3,1.3,0,1,0,128.2,55.2Z",
    transform: "translate(-104.269 -44.68)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10526",
    "data-name": "Group 10526",
    transform: "translate(70.366 13.331)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10525",
    "data-name": "Group 10525"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10131",
    "data-name": "Path 10131",
    d: "M140.1,81.8l-6.629-6.227a2.145,2.145,0,0,0-2.932,0L123.91,81.8a2.148,2.148,0,0,0-.676,1.561v9.058a2.143,2.143,0,0,0,2.141,2.141h13.258a2.143,2.143,0,0,0,2.141-2.141v-9.06A2.149,2.149,0,0,0,140.1,81.8Zm-7.145,10.17h-1.9V87.48h1.9Zm5.23,0h-2.64V86.66a1.772,1.772,0,0,0-1.77-1.77h-3.541a1.771,1.771,0,0,0-1.769,1.77v5.31h-2.64V83.553h0L132,77.748l6.18,5.805Z",
    transform: "translate(-123.234 -74.994)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10528",
    "data-name": "Group 10528",
    transform: "translate(58.95 0.009)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10527",
    "data-name": "Group 10527"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10132",
    "data-name": "Path 10132",
    d: "M127.661,36.512a1.293,1.293,0,0,0-1.3,1.286V87.352a.1.1,0,0,1-.1.1H61.638a.1.1,0,0,1-.1-.1V2.661a.1.1,0,0,1,.1-.1H105.7V20.309a2.724,2.724,0,0,0,2.735,2.707h17.928v6.726a1.3,1.3,0,0,0,2.589,0v-8.1a1.272,1.272,0,0,0-.02-.162h0a1.266,1.266,0,0,0-.044-.159.117.117,0,0,0-.014-.04,1.271,1.271,0,0,0-.065-.145V21.13a1.287,1.287,0,0,0-.09-.141l-.025-.034a1.273,1.273,0,0,0-.113-.13L107.908.375a1.279,1.279,0,0,0-.131-.111l-.035-.026A1.315,1.315,0,0,0,107.6.15h-.009a1.3,1.3,0,0,0-.145-.063l-.041-.015a1.3,1.3,0,0,0-.16-.044h-.006a1.325,1.325,0,0,0-.159-.02H61.638A2.678,2.678,0,0,0,58.95,2.67V87.348a2.678,2.678,0,0,0,2.688,2.661h64.623a2.678,2.678,0,0,0,2.688-2.661V37.794a1.293,1.293,0,0,0-1.289-1.282ZM108.288,4.374l16.249,16.081h-16.1a.146.146,0,0,1-.146-.144Z",
    transform: "translate(-58.95 -0.009)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10530",
    "data-name": "Group 10530",
    transform: "translate(96.013 47.423)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10529",
    "data-name": "Group 10529"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10133",
    "data-name": "Path 10133",
    d: "M295.764,287.5a.84.84,0,0,1,0-1.171,3.433,3.433,0,0,0-1.523-5.685.84.84,0,0,1-.586-1.014,3.433,3.433,0,0,0-4.162-4.162.839.839,0,0,1-1.014-.586,3.433,3.433,0,0,0-5.685-1.523.84.84,0,0,1-1.171,0,3.433,3.433,0,0,0-5.685,1.523.84.84,0,0,1-1.014.586,3.433,3.433,0,0,0-4.162,4.162.84.84,0,0,1-.585,1.014,3.433,3.433,0,0,0-1.523,5.685.84.84,0,0,1,0,1.171,3.433,3.433,0,0,0,1.523,5.685.84.84,0,0,1,.586,1.014,3.433,3.433,0,0,0,4.162,4.162.846.846,0,0,1,.36-.009V309.6a1.524,1.524,0,0,0,2.467,1.2l4.458-3.493,4.458,3.493a1.526,1.526,0,0,0,2.467-1.2V298.355a.843.843,0,0,1,.36.009,3.433,3.433,0,0,0,4.162-4.162.839.839,0,0,1,.585-1.014,3.433,3.433,0,0,0,1.523-5.685Zm-13.556,16.931a1.521,1.521,0,0,0-.941.326l-3.394,2.659v-6.264l.021.008c.051.022.1.041.156.061l.066.025c.076.026.153.05.231.071l.044.01c.06.015.119.03.179.042l.054.009c.057.01.113.021.17.028l.069.007c.051.006.1.012.154.015h.25c.09,0,.18-.005.27-.013l.068-.006c.1-.01.193-.023.288-.042h.016c.09-.018.179-.04.268-.066l.065-.019a2.391,2.391,0,0,0,.275-.1h.01c.086-.035.171-.075.255-.118l.063-.033c.086-.046.171-.094.253-.148h.006c.08-.052.158-.109.234-.169l.059-.047c.077-.063.153-.128.226-.2a.84.84,0,0,1,1.171,0c.062.06.125.116.191.17a3.4,3.4,0,0,0,2.929.713c.051-.011.1-.022.154-.036h.012q.111-.03.218-.067l.075-.028c.05-.018.1-.037.148-.057l.023-.009v6.263l-3.393-2.659a1.524,1.524,0,0,0-.942-.324ZM293.9,289.3a.843.843,0,0,1-.374,1.4,3.42,3.42,0,0,0-2.385,4.131.843.843,0,0,1-1.022,1.022A3.416,3.416,0,0,0,286.2,297.7c-.025.052-.049.1-.071.157-.014.033-.027.066-.04.1-.035.092-.068.186-.1.281a.837.837,0,0,1-.458.533.865.865,0,0,1-.134.048.9.9,0,0,1-.3.025.809.809,0,0,1-.5-.233,3.421,3.421,0,0,0-4.77,0,.9.9,0,0,1-.1.081l-.019.016-.021.012a.8.8,0,0,1-.176.084.83.83,0,0,1-.316.042.919.919,0,0,1-.174-.027.829.829,0,0,1-.592-.582c-.024-.084-.052-.167-.083-.248-.014-.037-.029-.073-.044-.109s-.032-.078-.049-.116-.049-.1-.074-.154l-.023-.043a3.414,3.414,0,0,0-3.016-1.818,3.486,3.486,0,0,0-.842.1.843.843,0,0,1-1.022-1.022,3.421,3.421,0,0,0-2.385-4.131.843.843,0,0,1-.374-1.4,3.42,3.42,0,0,0,0-4.77.843.843,0,0,1,.374-1.4A3.42,3.42,0,0,0,273.275,279a.843.843,0,0,1,1.022-1.022,3.421,3.421,0,0,0,4.131-2.385.843.843,0,0,1,1.4-.374,3.42,3.42,0,0,0,4.77,0,.843.843,0,0,1,1.4.374,3.42,3.42,0,0,0,4.131,2.385A.843.843,0,0,1,291.143,279a3.42,3.42,0,0,0,2.385,4.131.843.843,0,0,1,.374,1.4,3.42,3.42,0,0,0,0,4.769Z",
    transform: "translate(-267.69 -272.395)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10532",
    "data-name": "Group 10532",
    transform: "translate(101.628 53.294)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10531",
    "data-name": "Group 10531"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10134",
    "data-name": "Path 10134",
    d: "M314.477,306.578a8.909,8.909,0,1,0,0,12.605h0a8.923,8.923,0,0,0,0-12.605Zm-1.832,10.774a6.32,6.32,0,1,1,0-8.942,6.32,6.32,0,0,1,0,8.942Z",
    transform: "translate(-299.271 -303.972)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10534",
    "data-name": "Group 10534",
    transform: "translate(79.494 66.761)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10533",
    "data-name": "Group 10533"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10135",
    "data-name": "Path 10135",
    d: "M188.516,379.908H176.589a1.3,1.3,0,1,0,0,2.59h11.926a1.3,1.3,0,1,0,0-2.59Z",
    transform: "translate(-175.175 -379.903)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10536",
    "data-name": "Group 10536",
    transform: "translate(67.304 66.761)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10535",
    "data-name": "Group 10535"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10136",
    "data-name": "Path 10136",
    d: "M112.079,379.909H107.92a1.3,1.3,0,1,0,0,2.59h4.158a1.3,1.3,0,1,0,0-2.59Z",
    transform: "translate(-106.506 -379.904)",
    fill: "#00641f"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinanceleaseSelling);
export default __webpack_public_path__ + "static/media/financeleaseSelling.24d7cda53fab065e1aef0f070ca14454.svg";
export { ForwardRef as ReactComponent };